import React from "react";
import './Header.scss'
import { motion } from "framer-motion";
import { images } from "../../constants";
import { AppWrap } from "../../wrapper";

const Header = () => {
    const scaleVariants = {
        whileInView: {
            scale: [0, 1],
            opacity: [0, 1],
            transition: {
                duration: 1,
                ease: 'easeInOut'
            }
        }
    }
    
    return (
        <div className="app__header app__flex">
            <motion.div
                whileInView={{ x: [-100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__header-info"
            >
                <div className="app__header-badge">
                    <div className="badge-cmp app__flex">
                        <span>🙏👋</span>
                        <div style={{ marginLeft: 20 }}>
                            <p className="p-text">नमस्ते, I am</p>
                            <h1 className="head-text">Asish</h1>
                        </div>
                    </div>

                    <div className="tag-cmp app__flex">
                        <p className="p-text">Web</p>
                        <p className="p-text">Flutter</p>
                        <p className="p-text">Coffee</p>
                        <p className="p-text">India</p>
                        <p className="p-text">❤️💻☕️🇮🇳</p>
                    </div>
                </div>
            </motion.div>

            <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5, delayChildren: 0.5 }}
                className="app__header-img"
            >
                <img src={images.profile3} alt="profile-bg" />
                <motion.img
                    whileInView={{ scale: [0, 1] }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className="overlay-circle"
                    src={images.circle}
                    alt='profile-bg'
                />
            </motion.div>

            <motion.div
                variants={scaleVariants}
                whileInView={scaleVariants.whileInView}
                className="app__header-circles"
            >
                {[images.react, images.cpp, images.flutter].map((circle, index) => (
                    <div className="circle-cmp app__flex" key={index}>
                        <img src={circle} alt="circle" />
                    </div>
                )) }
            </motion.div>
        </div>
    )
}

export default AppWrap(Header, 'home')